import React, { memo } from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { Field, Form, SubmitButton } from '@bottomless/common/components';

const Schema = Yup.object().shape({
  pilotCategory: Yup.string().required('This field is required'),
  description: Yup.string().required('This field is required'),
  email: Yup.string()
    .email('Please enter a valid email address.')
    .required('Email is required.'),
});

const ProductRequestFormComponent = ({ onSubmit, referral_id, pilotCategory, placeholder }) => {
  const isMobile = useMediaQuery({ maxDeviceWidth: 767 });

  return (
    <Form
      initialValues={{
        referral_id: referral_id,
        pilotCategory: pilotCategory,
        description: '',
      }}
      validationSchema={Schema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <>
          <Field name="referral_id" hidden />
          <Field name="pilotCategory" hidden />
          <Field
            type="textarea"
            name="description"
            label="Product Link or Description"
            placeholder={placeholder}
            rows={isMobile ? '6' : '5'}
          />
          <Field type="email" name="email" label="Your Email Address" rows={isMobile ? '6' : '5'} />
          <div className="text-center text-md-left">
            <SubmitButton color="primary" isSubmitting={isSubmitting} loadingText="Submitting" size="md">
              Request Your Product
            </SubmitButton>
          </div>
        </>
      )}
    </Form>
  );
};

ProductRequestFormComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  referral_id: PropTypes.string.isRequired,
  pilotCategory: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export const ProductRequestForm = memo(ProductRequestFormComponent);
